import groq from 'groq';
import { EntityType } from '../types';

export const GetJobListingPageQuery = groq`*[_type == "${EntityType.JobListingPage}"][0]`;

export const GetJobsSeoQuery = groq`*[_type == "${EntityType.JobListingPage}"]{seoAttributes}[0]`;
